import * as tslib_1 from "tslib";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { noop, omit } from 'lodash';
import withFocusedState from "../../../enhancers/withFocusedState";
import { uniqueID } from "../../../utils";
import Label from '../Label';

var LabeledField =
/** @class */
function (_super) {
  tslib_1.__extends(LabeledField, _super);

  function LabeledField(props) {
    var _this = _super.call(this, props) || this;

    _this.inputId = uniqueID();
    return _this;
  }

  LabeledField.prototype.render = function () {
    var _a = this.props,
        label = _a.label,
        labelAlign = _a.labelAlign,
        containerClassName = _a.containerClassName,
        labelClassName = _a.labelClassName,
        kind = _a.kind,
        inputId = _a.inputId,
        disabled = _a.disabled,
        focused = _a.focused,
        isError = _a.isError,
        onLabelClick = _a.onLabelClick,
        children = _a.children,
        other = tslib_1.__rest(_a, ["label", "labelAlign", "containerClassName", "labelClassName", "kind", "inputId", "disabled", "focused", "isError", "onLabelClick", "children"]);

    var shared = {
      kind: kind,
      inputId: inputId || this.inputId,
      disabled: disabled,
      isError: isError
    };

    var fieldProps = tslib_1.__assign({}, shared, other, {
      focused: focused
    });

    return React.createElement(Label, tslib_1.__assign({}, shared, {
      text: label,
      align: labelAlign,
      containerClassName: containerClassName,
      labelClassName: labelClassName,
      isActive: focused,
      onClick: onLabelClick
    }), children(fieldProps));
  };

  LabeledField.propTypes = tslib_1.__assign({}, omit(Label.propTypes, ['text', 'align', 'multiline']), {
    label: PropTypes.node,
    labelAlign: PropTypes.string,
    focused: PropTypes.bool,
    children: PropTypes.func,
    onChange: PropTypes.func,
    onLabelClick: PropTypes.func
  });
  LabeledField.defaultProps = {
    focused: false,
    onLabelClick: noop
  };
  return LabeledField;
}(Component);

export default withFocusedState(LabeledField);

try {
  // @ts-ignore
  LabeledField.__docgenInfo = {
    "description": "",
    "displayName": "LabeledField",
    "props": {}
  };
} catch (__react_docgen_typescript_loader_error) {}